export default [
    {
        path: '',
        name: 'otherServices',
        component: () => import('./page-other-services')
    }
]